import fetchIntercept from "fetch-intercept";
import store from "./main.js";

const unregister = fetchIntercept.register({
  request: function (url, config) {
    // Modify the url or config here
    return [url, config];
  },

  requestError: function (error) {
    // Called when an error occured during another 'request' interceptor call
    return Promise.reject(error);
  },

  response: function (response) {
    // fetch does not reject promises for HTTP errors. Expire the local session
    // as soon as the API rejects the bearer token so a stale token cannot be
    // reused for subsequent requests.
    if (response && response.status === 401) {
      store.commit("logout");
    }
    return response;
  },

  responseError: function (error) {
    // Handle an fetch error
    return Promise.reject(error);
  },
});

export default unregister;
